import { tagAs } from 'factions/metatagger'
import { CHARGE_PHASE, COMBAT_PHASE, DURING_GAME, HERO_PHASE, MOVEMENT_PHASE, SAVES_PHASE, START_OF_HERO_PHASE } from 'types/phases'
import rule_sources from './rule_sources'
import { TItemDescriptions } from 'factions/factionTypes'

const CommandTraits = {
  /* 'Gnarled Warrior': {
    effects: [
      {
        name: `Gnarled Warrior`,
        desc: `Ignore modifiers (positive and negative) to save rolls for attacks that target this general.`,
        when: [SAVES_PHASE],
      },
    ],
  },
  'Lord of Spites': {
    effects: [
      {
        name: `Lord of Spites`,
        desc: `In the combat phase, subtract 1 from the Attacks characteristic of melee weapons used by enemy units (to a minimum of 1) that finish a pile-in move within 3" of this general until the end of that phase.`,
        when: [COMBAT_PHASE],
      },
    ],
  }, */
  'Spirit of the Dark Forest': {
    effects: [
      {
        name: `Spirit of the Dark Forest - Once Per Battle - Enemy Hero Phase`,
        desc: `Declare: Pick a visible enemy Hero to be the target.
        Effect: Halve the target's Move characteristic for the rest of the turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  Spellsinger: {
    effects: [
      {
        name: `Spellsinger - Passive`,
        desc: `Effect: If this unit is a Wizard, add 1 to casting rolls for this unit.
        If this unit is not a Wizard, it can use the 'Unbind' ability as if it had Wizard (1).`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Realmroot Guide': {
    effects: [
      {
        name: `Realmroot Guide - Once Per Battle`,
        desc: `Declare: This unit can only use this ability if it is wholly within the creeping overgrowth. Pick this unit and up to 1 other friendly Sylvaneth unit within this unit's combat range to be the targets. 
        Effect: Remove the targets from the battlefield and set them up again wholly within the creeping overgrowth and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'The Evergreen Hunt (AoR)': {
    effects: [
      {
        name: `Heartwood Hunting Horn (AoR) - Once Per Battle`,
        desc: `Effect: You gain 1 chord.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Lords of the Clan (AoR)': {
    effects: [
      {
        name: `Ancient Might (AoR) - Passive`,
        desc: `Effect: This unit can use Charge abilities even if it is in combat. If the charge roll is 3 or less when it does so, it does not count as having charged.`,
        when: [CHARGE_PHASE],
      },
    ],
  },
  'Soulpod Guardians (AoR)': {
    effects: [
      {
        name: `Devoted Protector (AoR) - Passive`,
        desc: `Effect: If this unit is destroyed while it is wholly within 12" of your Soulpod Grove, before removing this unit from the battlefield, Heal (10) your Soulpod Grove.`,
        when: [DURING_GAME],
      },
    ],
  },
  // Evergreen Hunt
  /*  'Sapwood Leader': {
    effects: [
      {
        name: `Sapwood Leader`,
        desc: `When you use the Abundant Growth battle trait to heal this general, you can heal up to D3 wounds allocated to this general instead of 1.`,
        when: [START_OF_HERO_PHASE],
      },
    ],
  }, */
} satisfies TItemDescriptions

export default tagAs(CommandTraits, 'command_trait')
